import { render, staticRenderFns } from "./IndexOpportunities.vue?vue&type=template&id=1fc820ac&scoped=true&"
import script from "./IndexOpportunities.vue?vue&type=script&lang=js&"
export * from "./IndexOpportunities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc820ac",
  null
  
)

export default component.exports